import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#FFE15A"
  }} d="M11.668,412.91c6.901,6.688,16.3,10.812,26.669,10.814h111.732L500.332,99.09  c-6.902-6.69-16.306-10.814-26.677-10.814H361.931L11.668,412.91z" /><path style={{
    fill: "#73AF00"
  }} d="M11.668,412.91L361.931,88.276H38.345C17.167,88.276,0,105.443,0,126.621V385.38  C0,396.185,4.477,405.94,11.668,412.91z" /><path style={{
    fill: "#FF4B55"
  }} d="M500.332,99.09L150.069,423.724h323.594C494.837,423.72,512,406.554,512,385.379V126.621  C512,115.815,507.523,106.06,500.332,99.09z" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };